import { Container, Divider, Typography } from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  container: {
    left: 0,
    bottom: 0,
    width: "100%",
    overflow: "hidden",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    alignItems: "center",
  },
  fixedHeight: {
    height: "100%",
  },
}));

export default function Copyright() {
  const classes = useStyles();

  return (
    <Container maxWidth="xl" className={classes.container}>
       <Divider/>
      <Typography variant="body2" color="textSecondary" align="center">
        {" © ".concat(process.env.copyrightData)}
        {/* &nbsp; Designed & Developed by
        <Link color="inherit" href={`${process.env.copyright}`}>
          <a target="_blank"> Knowledge Broadband Services</a>
        </Link>{" "}
        {new Date().getFullYear()}
        {"."} */}
      </Typography>
      <Container style={{width: "100%", display: "flex", justifyContent: "center"}}>     
         <img src={process.env.chamberName === 'messinia' ? "/espa-messinia.jpg" : "/espa.jpg"} alt='espa2014-2020 EU' style={{maxWidth:"100%", maxHeight:"100%"}} />
      </Container>
      <InputLabel align="center" className={classes.footerText}>
                        <a href="/TermsConditions" >
                              Όροι Χρήσης
                        </a>
                        {' '}|{' '}
                        <a href="/PrivacyPolicy" >
                            Πολιτική Ασφάλειας
                        </a>
      </InputLabel>
    </Container>
  );
}
